import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-rating-face-5",
  "use": "foquz-icon-rating-face-5-usage",
  "viewBox": "0 0 15 12",
  "content": "<symbol viewBox=\"0 0 15 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-rating-face-5\"><path d=\"M5.203 2.695A2.972 2.972 0 001 2.664m13 .03a2.973 2.973 0 00-4.203-.03M12 9a6.361 6.361 0 01-2.054 1.47 6.085 6.085 0 01-2.432.53 6.08 6.08 0 01-2.44-.492A6.346 6.346 0 013 9.07\" stroke=\"#fff\" stroke-width=\"2\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol